import { Location } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesService } from '@services/routes/routes.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from '../services/auth/auth.service';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor
{

    constructor(
        private router: Router,
        private location: Location,
        private injector: Injector
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        if (!req.url.startsWith('/api')) return next.handle(req);
        // if (!req.url.startsWith('/nft-public')) return next.handle(req);

        return next.handle(req).pipe(
            catchError((error, caught) =>
            {
                const currentPath = this.location.path();
                if (
                    error.status == 401 &&
                    !currentPath.includes('/sign-in') &&
                    !currentPath.includes('/create-external')
                )
                {
                    if (currentPath)
                    {
                        const routesService = this.injector.get(RoutesService);
                        routesService.saveRoute('sign-in-redirect', currentPath);
                    }
                    const authService = this.injector.get(AuthService);
                    authService.logOut(false);
                }

                return throwError(error);
            })
        );
    }
}
